/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Text,
	Box,
	Image,
	Avatar,
	Group,
} from '@mantine/core';

// Styles
import classes from './ListProjects.module.css';

// Mock
import { getCountryName } from '@utils/countries';
import {
	formatCurrency,
	formatTwoDecimals,
} from '@utils/formats';
import { getCurrencyUnit } from '@utils/currency-units';
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const ListProjects = (props: {
	selectedProjects: any[];
	type: string;
}) => {
	const { t } = useTranslation();
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Box className={classes.header}>
				<Box className={classes.col3}>
					{t('global.project')}
				</Box>
				{props.type == 'mesurability' && (
					<Box className={classes.col1}>
						{t(
							'offsets.qteOfTco2eqCompensatedTotalPerSite'
						)}
					</Box>
				)}
				<Box className={classes.col1}>
					{t('offsets.totalPerSite')}
				</Box>
			</Box>
			<Box className={classes.containerItems}>
				{props.selectedProjects &&
					props.selectedProjects.map((item) => (
						<Box className={classes.item}>
							<Box className={classes.col3}>
								<Box className={classes.containerProject}>
									<Image
										radius={'md'}
										className={classes.itemImage}
										src={item.image}
									/>
									<Box className={classes.containerTexts}>
										<Text className={classes.itemName}>
											{item.name}
										</Text>
										<Box className={classes.country}>
											<Avatar
												radius={'xl'}
												src={`https://flagcdn.com/w40/${item.country.code.toLowerCase()}.png`}
												size={'xs'}
											/>
											<Text className={classes.itemType}>
												{getCountryName(
													item.country.code
												)}
											</Text>
										</Box>
										<Text className={classes.itemType}>
											{t(item.type)}
										</Text>
									</Box>
								</Box>
							</Box>
							{props.type == 'mesurability' && (
								<Box className={classes.col1}>
									{formatTwoDecimals(
										parseFloat(item.quantitytco2eq)
									)}
								</Box>
							)}
							<Box className={classes.col1}>
								{props.type == 'mesurability' && (
									<Box className={classes.containerTotal}>
										{formatCurrency(
											parseFloat(item.quantitytco2eq) *
												parseFloat(
													item.sellPrice_europertco2eq
												),
											getCurrencyUnit('EUR')
										)}
										<Group gap={'2px'}>
											<Text className={classes.unitTotal}>
												{formatTwoDecimals(
													parseFloat(item.priceTco2)
												)}
											</Text>
											<Text
												className={classes.unitSmallTotal}
											>
												{'€ / t'}
											</Text>
										</Group>
									</Box>
								)}
								{props.type != 'mesurability' && (
									<Box className={classes.containerTotal}>
										{formatCurrency(
											Number(item.price),
											getCurrencyUnit('EUR')
										)}
									</Box>
								)}
							</Box>
						</Box>
					))}
			</Box>
		</Box>
	);
};
